'use client';
import { RouterLink, useSearchParams } from '@/navigation';
import { Chip } from '@mui/material';

export interface Props {
  sku?: string;
  active?: boolean;
  label: string;
  basePath: string;
}

export function ProductVariantChip({ sku, active, label, basePath }: Props) {
  const searchParams = useSearchParams();

  if (!sku)
    return (
      <Chip
        label={<div dangerouslySetInnerHTML={{ __html: label }} />}
        color={active ? 'primary' : 'default'}
        disabled
      />
    );

  const query = { ...Object.fromEntries(searchParams), sku };
  return (
    <RouterLink
      href={{
        pathname: basePath,
        query: query,
      }}
      prefetch
    >
      <Chip
        label={<div dangerouslySetInnerHTML={{ __html: label }} />}
        color={active ? 'primary' : 'default'}
        disabled={!sku}
      />
    </RouterLink>
  );
}
